import type { Cart } from '@/types/Cart';
import PQueue from 'p-queue';

type QueuedTask = () => Promise<any>;

export const useCartStore = defineStore('cart', () => {
  const queue = new PQueue({ concurrency: 1 });
  const cartsLoaded = ref(false);

  const carts = ref<Cart[]>([]);

  const activeCart = ref<Cart | undefined>(undefined);

  const productCount = computed(() => {
    return carts.value.reduce((acc, cart) => acc + cart.products.length, 0);
  });

  const addCartStore = async (cart: Cart) => {
    carts.value.push(cart);
  };

  const updateCartStore = (updatedCart: Cart) => {
    const index = carts.value.findIndex((cart) => cart.id === updatedCart.id);

    if (index !== -1) {
      carts.value.splice(index, 1, updatedCart);
    }
  };

  const removeCartStore = (id: number) => {
    const index = carts.value.findIndex((cart) => cart.id === id);

    if (index !== -1) {
      carts.value.splice(index, 1);
    }
  };

  const resetCarts = () => {
    carts.value = [];
    activeCart.value = undefined;
    cartsLoaded.value = false;
  };

  const addQueuedTask = async (task: QueuedTask) => {
    await queue.add(task);
  };

  return {
    cartsLoaded,
    carts,
    productCount,
    activeCart,
    addCartStore,
    updateCartStore,
    removeCartStore,
    resetCarts,
    addQueuedTask,
  };
});
